namespace $.$$ {
	export class $shm_mentionstat_filter_panel extends $.$shm_mentionstat_filter_panel {
		query_rows() { return this.query_values().map( value => this.Query_row( value ) ) }
		scope_rows() { return this.scope_values().map( value => this.Scope_row( value ) ) }
		country_rows() { return this.country_values().map( value => this.Country_row( value ) ) }
		language_rows() { return this.language_values().map( value => this.Language_row( value ) ) }
		type_rows() { return this.type_values().map( value => this.Type_row( value ) ) }
		category_rows() { return this.category_values().map( value => this.Category_row( value ) ) }
		query_title( value: string ) { return value }
		scope_title( value: string ) { return value }
		country_title( value: string ) { return value || 'Не указана' }
		language_title( value: string ) { return value || 'Не указан' }
		type_title( value: string ) { return value || 'Не указан' }
		category_title( value: string ) { return value || 'Не указана' }
	}
}
